<template lang="pug">
	transition(name="fade")
		div(id="fondoModal")
			div
				div(:style="{'max-width' : ancho, 'margin-top': arriba}")
					slot
</template>

<script>
export default {
	props: ['maxWidth', 'top'],
	computed: {
		ancho () {
			if (!this.maxWidth) {
				return 'default'
			} else {
				return this.maxWidth + 'px'
			}
		},
		arriba () {
			if (!this.top) {
				return 'default'
			} else {
				return this.top + 'px'
			}
		}
	}
}
</script>

<style>
	.fade-enter-active, .fade-leave-active {
		transition: opacity .3s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/modal/modal.vue